import { useContext } from 'react';
import { NotificationsContext } from '.';

// eslint-disable-next-line import/prefer-default-export
export const useNotifications = () => useContext(NotificationsContext);
